module.exports = __webpack_public_path__ + "img/kppz1.2167b6ac.png";